import watch from 'redux-watch';
import shopListTitleTpl from './shop-list-title.tpl.html!text';

class ShopListTitleCtrl {

    constructor($scope, $element, storeServ,$location) {
        this.$scope = $scope;
        this.$element = $element;
        this.storeServ = storeServ;
        this.$location = $location;
        this.ngOnInit();
    }

    ngOnInit() {
        this.$element.ready(this.subscribeToStore.bind(this));

        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    subscribeToStore() {
        let watchShopsInBounds = watch(this.storeServ.getState, 'shopsInBounds');

        this.stopWatchingShopsInBounds = this.storeServ.subscribe(watchShopsInBounds((shopsInBounds, oldShopsInBounds, objectPath) => {
            if (shopsInBounds) {
                this.$element.find('.shop-list-title-when-shops').removeClass('shop-list-title-hidden');
                this.$element.find('.shop-list-title-when-no-shops').addClass('shop-list-title-hidden');
            } else {
                this.$element.find('.shop-list-title-when-shops').addClass('shop-list-title-hidden');
                this.$element.find('.shop-list-title-when-no-shops').removeClass('shop-list-title-hidden');
            }
        }));
    }

    ngOnDestroy() {
        this.stopWatchingShopsInBounds();
    }
}

ShopListTitleCtrl.$inject = ['$scope', '$element', 'storeServ','$location'];

var shopListTitleDirective = function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: shopListTitleTpl,
        scope: {},
        controllerAs: 'ctrl',
        controller: ShopListTitleCtrl
    };
};

export default shopListTitleDirective;
